var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticleTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 28.94,
    height: 28.94,
    viewBox: "0 0 28.94 28.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "article-type"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27376",
    "data-name": "Rectangle 27376",
    width: 28.94,
    height: 28.94,
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_376",
    "data-name": "Mask Group 376",
    clipPath: "url(#article-type)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_1_",
    "data-name": "svgexport-7 (1)",
    transform: "translate(3.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M16.8,8.372a1.956,1.956,0,0,1-1.953-1.953V0H4.857a3.073,3.073,0,0,0-3.07,3.07V25.506a3.073,3.073,0,0,0,3.07,3.07H20.484a3.073,3.073,0,0,0,3.07-3.07V8.372ZM6.364,20.092h4.059a.837.837,0,1,1,0,1.674H6.364a.837.837,0,1,1,0-1.674Zm-.837-3.628a.837.837,0,0,1,.837-.837H18.642a.837.837,0,1,1,0,1.674H6.364A.837.837,0,0,1,5.526,16.464Zm13.116-5.3a.837.837,0,1,1,0,1.674H6.364a.837.837,0,1,1,0-1.674Z",
    transform: "translate(-1.787)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M9.521,6.253a.279.279,0,0,0,.279.279h6.38a3.062,3.062,0,0,0-.587-.766L10.212.675A3.077,3.077,0,0,0,9.522.182V6.253Z",
    transform: "translate(5.213 0.165)",
    fill: "#7e59d1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleTypeIcon);
export default __webpack_public_path__ + "static/media/article-type-icon.eb0e17644c01a50d5085cd31c886d2ce.svg";
export { ForwardRef as ReactComponent };